<app-upload-file
  [currentFiles]="currentFiles"
  [hasPendingUpload]="hasPendingUpload"
  (navigate)="navigateOrRefreshList()"
  (closeOverlay)="closeOverlay()"
></app-upload-file>
